module.exports = __webpack_public_path__ + "media/company.c9fadcd1.mp4";